import { Component, ElementRef, Input, NgModule } from '@angular/core';
import SignaturePad from 'signature_pad';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-signaturepad.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxSignaturepadComponent {
    /**
     * @param {?} _el
     */
    constructor(_el) {
        this._el = _el;
        this._width = 200;
        this._height = 200;
        this._options = {};
    }
    /**
     * @param {?} options
     * @return {?}
     */
    set options(options) {
        this._options = options;
        if (this._signaturePad) {
            this._signaturePad = new SignaturePad(this._canvas, this._options || {});
        }
    }
    ;
    /**
     * @param {?} value
     * @return {?}
     */
    set width(value) {
        this._width = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set height(value) {
        this._height = value;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.options) {
            this._options = this.options;
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._canvas = this._el.nativeElement.querySelector("canvas");
        this._signaturePad = new SignaturePad(this._canvas, this._options || {});
    }
    /**
     * @param {?=} type
     * @return {?}
     */
    toDataURL(type = null) {
        return this._signaturePad.toDataURL(type);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    fromDataURL(data) {
        this._signaturePad.fromDataURL(data);
    }
    /**
     * @return {?}
     */
    toData() {
        return this._signaturePad.toData();
    }
    /**
     * @param {?} data
     * @return {?}
     */
    fromData(data) {
        this._signaturePad.fromData(data);
    }
    /**
     * @return {?}
     */
    clear() {
        this._signaturePad.clear();
    }
    /**
     * @return {?}
     */
    isEmpty() {
        return this._signaturePad.isEmpty();
    }
    /**
     * @return {?}
     */
    off() {
        this._signaturePad.off();
    }
    /**
     * @return {?}
     */
    on() {
        this._signaturePad.on();
    }
}
NgxSignaturepadComponent.ɵfac = function NgxSignaturepadComponent_Factory(t) { return new (t || NgxSignaturepadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxSignaturepadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxSignaturepadComponent, selectors: [["ngx-signaturepad"]], inputs: { options: "options", width: "width", height: "height" }, decls: 1, vars: 2, consts: [[2, "touch-action", "none", 3, "width", "height"]], template: function NgxSignaturepadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "canvas", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("width", ctx._width)("height", ctx._height);
    } }, encapsulation: 2 });
/** @nocollapse */
NgxSignaturepadComponent.ctorParameters = () => [
    { type: ElementRef }
];
NgxSignaturepadComponent.propDecorators = {
    options: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSignaturepadComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-signaturepad',
                template: '<canvas [width]="_width" [height]="_height" style="touch-action: none;"></canvas>'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { options: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NgxSignaturepadComponent.prototype._width;
    /** @type {?} */
    NgxSignaturepadComponent.prototype._height;
    /** @type {?} */
    NgxSignaturepadComponent.prototype._options;
    /**
     * @type {?}
     * @private
     */
    NgxSignaturepadComponent.prototype._canvas;
    /**
     * @type {?}
     * @private
     */
    NgxSignaturepadComponent.prototype._signaturePad;
    /**
     * @type {?}
     * @private
     */
    NgxSignaturepadComponent.prototype._el;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-signaturepad.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxSignaturepadModule {
}
NgxSignaturepadModule.ɵfac = function NgxSignaturepadModule_Factory(t) { return new (t || NgxSignaturepadModule)(); };
NgxSignaturepadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSignaturepadModule });
NgxSignaturepadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSignaturepadModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxSignaturepadComponent],
                imports: [],
                exports: [NgxSignaturepadComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSignaturepadModule, { declarations: [NgxSignaturepadComponent], exports: [NgxSignaturepadComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-signaturepad2.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxSignaturepadComponent, NgxSignaturepadModule };

